import React, { PureComponent } from "react";
import {
  serviceCaller,
  ServiceCallerProps,
  withModals,
} from "../../composition";
import { firebaseConnect, isEmpty, isLoaded } from "react-redux-firebase";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import classNames from "classnames";
import get from "lodash.get";
import ISegment from "../../../types/services/ISegment";
import {
  Row,
  Col,
  Button,
  InputGroup,
  InputGroupText,
  Input,
} from "reactstrap";
import Fragment from "../../../toolkit/fragment";
import { ScaleLoader } from "react-spinners";
import ModalFrame from "../../../toolkit/modalFrame";
import { getFlagsForDonor, setFlagsForDonor } from "../../../utils/fetch";
import ISetFlagsForDonorRequest from "../../../types/services/ISetFlagsForDonorRequest";
import * as modalActions from "../../../utils/actions/modals";
import firebase from "firebase/compat/app";

interface Props extends ServiceCallerProps {
  donorId: string;
  isOpen: boolean;
  updateComponentFunction: () => void;
  toggle: () => void;
  firebase: firebase.app.App;
  segments: Array<ISegment>;
}

type DisplayState = "normal" | "confirm" | "success";

interface State {
  loaded: boolean;
  displayState: DisplayState;
  fetchMessage: string;
  isError: boolean;
  errorText: string;
  flagsToAdd: Array<ISegment>;
  flagsToRemove: Array<ISegment>;
  allFlags: Array<ISegment>;
  belongingFlags: Array<ISegment>;
  flagsToShow: Array<ISegment>;
  searchText: string;
  searchTextUsed: string;
}

class SegmentManagerModal extends PureComponent<Props, State> {
  state = {
    loaded: false,
    displayState: "normal" as DisplayState,
    fetchMessage: "",
    isError: false,
    errorText: undefined,
    flagsToAdd: [] as Array<ISegment>,
    flagsToRemove: [] as Array<ISegment>,
    allFlags: [] as Array<ISegment>,
    belongingFlags: [] as Array<ISegment>,
    flagsToShow: [] as Array<ISegment>,
    searchText: "",
    searchTextUsed: "",
  };

  searchTimeout = null;

  onCheckElement = segment => {
    let newArrayAdd = [];
    let newArrayDelete = [...this.state.flagsToRemove];
    if (this.state.flagsToAdd.includes(segment)) {
      newArrayAdd = [...this.state.flagsToAdd];
      let index = newArrayAdd.indexOf(segment);
      newArrayAdd.splice(index, 1);

      newArrayDelete = [...this.state.flagsToRemove];
      newArrayDelete.push(segment);
    } else if (this.state.flagsToRemove.includes(segment)) {
      newArrayDelete = [...this.state.flagsToRemove];
      let index = newArrayDelete.indexOf(segment);
      newArrayDelete.splice(index, 1);

      newArrayAdd = [...this.state.flagsToAdd];
      newArrayAdd.push(segment);
    } else {
      newArrayAdd = [...this.state.flagsToAdd];
      newArrayAdd.push(segment);
    }
    this.setState({
      flagsToAdd: newArrayAdd,
      flagsToRemove: newArrayDelete,
    });
  };

  sortSegments(newSegmentList: Array<ISegment>): Array<ISegment> {
    newSegmentList.sort(function(a, b) {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    return newSegmentList;
  }

  loadFlagsForDonor = (): void => {
    if (
      !this.props.isOpen ||
      !this.props.segments ||
      !this.props.config ||
      !this.props.donorId ||
      this.state.loaded
    ) {
      return;
    }

    const allFlags = this.sortSegments(this.props.segments).filter(
      segment => segment.isDonorList
    );
    getFlagsForDonor(
      this.props.config.searchServiceUrl,
      this.props.currentCharity.id,
      this.props.donorId,
      this.props.serviceAccessToken
    ).then(flags => {
      const realFlags = allFlags.filter(
        flag =>
          flags.filter(internalFlag => internalFlag.id == flag.id).length > 0
      );
      this.setState({
        belongingFlags: realFlags,
        allFlags: allFlags,
        flagsToShow: allFlags,
        flagsToAdd: realFlags,
        loaded: true,
      });
    });
  };

  componentDidMount(): void {
    this.loadFlagsForDonor();
  }

  componentDidUpdate(prevProps: Props, prevState: State): void {
    const modalOpened = !prevProps.isOpen && this.props.isOpen;
    const donorChangedWhileOpen =
      this.props.isOpen && prevProps.donorId !== this.props.donorId;
    const segmentsReadyWhileOpen =
      this.props.isOpen &&
      !this.state.loaded &&
      this.props.segments &&
      prevProps.segments !== this.props.segments;

    if (modalOpened || donorChangedWhileOpen) {
      this.setState({ loaded: false }, () => this.loadFlagsForDonor());
    } else if (segmentsReadyWhileOpen) {
      this.loadFlagsForDonor();
    }

    if (prevProps.isOpen && !this.props.isOpen && this.state.loaded) {
      this.setState({
        loaded: false,
        displayState: "normal",
        errorText: "",
        searchTextUsed: "",
        searchText: "",
      });
    }

    if (prevState.searchTextUsed !== this.state.searchTextUsed) {
      if (!this.state.searchTextUsed || this.state.searchTextUsed === "") {
        this.setState({
          flagsToShow: this.state.allFlags,
        });
      } else {
        let filteredFlags = this.state.allFlags.filter(flag =>
          flag.name
            .toLowerCase()
            .includes(this.state.searchTextUsed.toLowerCase())
        );
        this.setState({
          flagsToShow: filteredFlags,
        });
      }
    }
  }

  searchTextChange = e => {
    const newText: string = e.target.value;
    if (!newText || newText.length >= 3 || newText.length == 0) {
      if (this.searchTimeout && window) {
        window.clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      this.setState({
        searchText: newText,
        searchTextUsed: newText,
      });
    } else {
      if (window) {
        if (this.searchTimeout) {
          window.clearTimeout(this.searchTimeout);
        }
        this.setState({
          searchText: newText,
        });
        this.searchTimeout = window.setTimeout(() => {
          this.setState({
            searchTextUsed: newText,
          });
        }, 1500);
      }
    }
  };

  resetSearch = () => {
    this.setState({
      searchText: "",
      searchTextUsed: "",
      errorText: undefined,
    });
  };

  getElementIsChecked = segment => {
    return this.state.flagsToAdd.includes(segment);
  };

  getFlagsToShow = () => {
    let newArray = [...this.state.flagsToShow];
    return (
      <Fragment>
        <Row className={s.generalMargin}>
          <Col xs={12}>
            <InputGroup>
              <InputGroupText className={s.inputGroup}>
                <i className={"fa fa-search " + s.searchIcon}>&nbsp;</i>
              </InputGroupText>
              <Input
                id="searchText"
                placeholder={"Segment Name"}
                value={this.state.searchText}
                onChange={this.searchTextChange}
                className={s.noBorder}
              />
              <InputGroupText
                className={s.inputGroupRight}
              >
                <i
                  className={"fa fa-times " + s.closeIcon}
                  onClick={this.resetSearch}
                >
                  &nbsp;
                </i>
              </InputGroupText>
            </InputGroup>
          </Col>
        </Row>
        <Row key={"header"}>
          <Col xs={2} className={s.offsetHeader} />
          <Col xs={10} className={s.headerDiv}>
            Segment Name
          </Col>
        </Row>
        {newArray.map((segment, index) => (
          <Row
            key={segment.id}
            className={(index + 1) % 2 === 0 ? "" : s.oddRow}
          >
            <Col xs={2} className={s.borderR}>
              <div
                onClick={() => this.onCheckElement(segment)}
                className={s.checkBoxDiv}
              >
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.getElementIsChecked(segment)}
                  onChange={() => {}}
                />
                <label
                  htmlFor="checkbox"
                  key={segment.id}
                  className={
                    this.getElementIsChecked(segment) ? s.checked : s.noCheck
                  }
                />
              </div>
            </Col>
            <Col xs={10} className={s.textDiv}>
              {segment.name}
            </Col>
          </Row>
        ))}
      </Fragment>
    );
  };

  onAdd = () => {
    let addFiltered = this.state.flagsToAdd.filter(
      segment => !this.state.belongingFlags.includes(segment)
    );
    let deletedFiltered = this.state.flagsToRemove.filter(segment =>
      this.state.belongingFlags.includes(segment)
    );
    if (addFiltered.length === 0 && deletedFiltered.length === 0) {
      this.setState({
        errorText: "You have to make at least one change",
      });
    } else {
      this.setState({ displayState: "confirm" });
    }
  };

  cancelAdd = () => {
    this.setState({ displayState: "normal" });
  };

  getSummary = () => {
    let addFiltered = this.state.flagsToAdd.filter(
      segment => !this.state.belongingFlags.includes(segment)
    );
    let deletedFiltered = this.state.flagsToRemove.filter(segment =>
      this.state.belongingFlags.includes(segment)
    );

    let addNames = "";
    let deletedNames = "";

    addFiltered.forEach((segment, index) => {
      if (index === addFiltered.length - 1) {
        addNames += segment.name;
      } else {
        addNames += segment.name + ", ";
      }
    });

    deletedFiltered.forEach((segment, index) => {
      if (index === deletedFiltered.length - 1) {
        deletedNames += segment.name;
      } else {
        deletedNames += segment.name + ", ";
      }
    });

    return (
      <ul>
        {addFiltered.length > 0 && (
          <li>
            <span>Adding donor to </span>
            <strong>{addFiltered.length}</strong>
            <span> Segments:</span>
            <br />
            <span>{addNames}</span>
          </li>
        )}
        <br />
        {deletedFiltered.length > 0 && (
          <li>
            <span>Removing donor from </span>
            <strong>{deletedFiltered.length}</strong>
            <span> Segments:</span>
            <br />
            <span>{deletedNames}</span>
          </li>
        )}
      </ul>
    );
  };

  addSegments = () => {
    let addFiltered = this.state.flagsToAdd.filter(
      segment => !this.state.belongingFlags.includes(segment)
    );
    let deletedFiltered = this.state.flagsToRemove.filter(segment =>
      this.state.belongingFlags.includes(segment)
    );
    setFlagsForDonor(
      this.props.config.searchServiceUrl,
      this.props.currentCharity.id,
      {
        donorId: this.props.donorId,
        flagsToAdd: addFiltered,
        flagsToDelete: deletedFiltered,
      } as ISetFlagsForDonorRequest,
      this.props.serviceAccessToken
    ).then(response => {
      this.setState(
        {
          fetchMessage: response,
          displayState: "success",
        },
        () => {
          this.props.updateComponentFunction();
        }
      );
    });
  };

  render() {
    return (
      <ModalFrame
        title={"Segment Manager"}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        size="l"
        className={s["modal-xs"]}
      >
        <div className={s.centered}>
          <ScaleLoader color={"#1f65b1"} loading={!this.state.loaded} />
        </div>
        {this.state.loaded && this.state.displayState === "normal" && (
          <div>
            <div className={classNames(s.hiddenScroll, "container-fluid")}>
              {this.getFlagsToShow()}
            </div>
            {this.state.errorText && (
              <Row className={s.error}>
                <span className={s.centeredText}>{this.state.errorText}</span>
              </Row>
            )}
            <Row>
              <Button className={s.button} onClick={this.onAdd}>
                {`Make Changes`}
              </Button>
            </Row>
          </div>
        )}
        {this.state.loaded && this.state.displayState === "confirm" && (
          <div>
            <Row className={s.confirmMessage}>
              <div className={s.margin}>
                {"Are you sure you want to make this changes"}
                <br />
                <br />
                {this.getSummary()}
              </div>
            </Row>
            <Row>
              <Col xs={6} className={s.rightCol}>
                <Button className={s.button} onClick={this.cancelAdd}>
                  Cancel
                </Button>
              </Col>
              <Col xs={6} className={s.leftCol}>
                <Button className={s.button} onClick={this.addSegments}>
                  Accept
                </Button>
              </Col>
            </Row>
          </div>
        )}
        {this.state.loaded && this.state.displayState === "success" && (
          <div>
            <Row className={s.fetchMessage}>
              <span className={s.centeredText}>Donor Updated Successfully</span>
            </Row>
            <Row>
              <Button className={s.button} onClick={this.props.toggle}>
                Close
              </Button>
            </Row>
          </div>
        )}
      </ModalFrame>
    );
  }
}

const mapStateToProps = state => {
  const { firebase, user } = state;
  let segments =
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].segments)
      ? !isEmpty(firebase.data[user.currentCharity.id].segments)
        ? get(firebase, `ordered.${user.currentCharity.id}.segments`)
        : []
      : null;
  if (segments && Array.isArray(segments)) {
    segments = segments.map(segmentF => {
      return {
        ...segmentF.value,
        id: segmentF.key,
      };
    });
  } else {
    segments = [];
  }
  return {
    firebase: firebase,
    segments: segments,
  };
};

const mapDispatchToProps = dispatch => ({
  toggleSegmentManagerModal: (donorId = null) => {
    dispatch(modalActions.toggleSegmentManagerModal(donorId));
  },
});

export default serviceCaller(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    withModals(
      firebaseConnect((_, store) => {
        return store.getState().user.currentCharity.id !== ""
          ? [
              {
                path: `${store.getState().user.currentCharity.id}/segments`,
              },
            ]
          : [];
      })(withStyles(s)(SegmentManagerModal))
    )
  )
);
